import React from "react";
import { isPlatformSessionMode } from "../auth/mode";
import { isAzureLoginEnabled, isSfLoginEnabled } from "../auth/azureConfig";
import { AuthProvider } from "../auth/AuthContext";
import { AzureAuthProvider } from "../auth/AzureAuthContext";
import { SalesforceAuthProvider } from "../auth/SalesforceAuthContext";
import ErrorBoundary from "./ErrorBoundary";
import { ServiceProvider } from "../context/ServiceProvider";
import { SessionErrorProvider } from "./SessionErrorHandler";
import { MobileMenuProvider } from "../context/MobileMenuContext";
export default function AppProviders({ children }) {
  const content = (
    <>
      <ErrorBoundary>
        <SessionErrorProvider>
          <ServiceProvider>
            <MobileMenuProvider>{children}</MobileMenuProvider>
          </ServiceProvider>
        </SessionErrorProvider>
      </ErrorBoundary>
    </>
  );
  if (isPlatformSessionMode()) {
    return content;
  }
  const withAzure = isAzureLoginEnabled();
  const withSf = isSfLoginEnabled();
  const authContent = <AuthProvider>{content}</AuthProvider>;
  const withSfContent = withSf ? (
    <SalesforceAuthProvider>{authContent}</SalesforceAuthProvider>
  ) : (
    authContent
  );
  const withAzureContent = withAzure ? (
    <AzureAuthProvider>{withSfContent}</AzureAuthProvider>
  ) : (
    withSfContent
  );
  return withAzureContent;
}
